"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoveryPillarOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const structural_organisms_1 = require("../structural-organisms");
const RecoveryWeekPreviewTable_1 = __importDefault(require("./RecoveryWeekPreviewTable"));
const hooks_1 = require("../../shared/hooks");
const CollapseRecoveryMobile_1 = __importDefault(require("./CollapseRecoveryMobile"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const RecoveryPillarOverview = (props) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const content = isMobile
        ? [
            (0, jsx_runtime_1.jsx)(CollapseRecoveryMobile_1.default, { title: t("recovery.recovery"), valuesMap: props.recoveryMap, startDay: props.startDay, onHeaderClick: props.onHeaderClick, getDateFns: props.getDateFns }, "mobile_recovery"),
            (0, jsx_runtime_1.jsx)(CollapseRecoveryMobile_1.default, { title: t("recovery.progress"), valuesMap: props.progressMap, startDay: props.startDay, onHeaderClick: props.onHeaderClick, onLogbookClick: props.onLogbookClick, showChecklistChange: props.showChecklistChange, getDateFns: props.getDateFns, isProgress: true }, "mobile_progress")
        ]
        : [
            (0, jsx_runtime_1.jsx)(RecoveryWeekPreviewTable_1.default, { title: t("recovery.recovery"), valuesMap: props.recoveryMap, startDay: props.startDay, isAverage: props.isAverage, onHeaderClick: props.onHeaderClick, getDateFns: props.getDateFns }, "web_recovery"),
            (0, jsx_runtime_1.jsx)(RecoveryWeekPreviewTable_1.default, { title: t("recovery.progress"), valuesMap: props.progressMap, isProgress: true, startDay: props.startDay, isAverage: props.isAverage, onHeaderClick: props.onHeaderClick, onLogbookClick: props.onLogbookClick, getDateFns: props.getDateFns, showChecklistChange: props.showChecklistChange }, "web_progress")
        ];
    return (0, jsx_runtime_1.jsx)(List, { children: content }, void 0);
};
exports.RecoveryPillarOverview = RecoveryPillarOverview;
const List = (0, styled_components_1.default)(structural_organisms_1.ListWithMargin) `
  margin-bottom: ${({ theme }) => theme.spacings.xl};

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=RecoveryPillarOverview.js.map